import type { ReactNode } from "react";
import { cx } from "../cx.ts";
import { TONE_SOFT, type Tone } from "./tone.ts";

export interface BadgeProps {
  tone?: Tone;
  icon?: ReactNode;
  className?: string;
  children: ReactNode;
}

/** A small, static status label (quote status, role, PDF state). */
export function Badge({ tone = "neutral", icon, className, children }: BadgeProps) {
  return (
    <span
      className={cx(
        "inline-flex items-center gap-1 whitespace-nowrap rounded-md border px-2 py-0.5 font-semibold text-xs uppercase tracking-wide",
        "sun:border-2 sun:border-black sun:text-sm",
        TONE_SOFT[tone],
        className,
      )}
    >
      {icon}
      {children}
    </span>
  );
}
